import baseRoute from '../baseRoute';

export default `${baseRoute}/location` as const;
